import { render, staticRenderFns } from "./WarrantyReceptionInfo.vue?vue&type=template&id=2ffdda32&scoped=true"
import script from "./WarrantyReceptionInfo.vue?vue&type=script&lang=js"
export * from "./WarrantyReceptionInfo.vue?vue&type=script&lang=js"
import style0 from "./WarrantyReceptionInfo.vue?vue&type=style&index=0&id=2ffdda32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ffdda32",
  null
  
)

export default component.exports